module.exports = __webpack_public_path__ + "img/jacket-right-sub-raglan-hood.5b563822.png";